import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

const emptyAccountState = {
  business_name: "",
  business_type: "",
  beneficiary_name: "",
  email: "",
  phone: "",
  account_no: "",
  account_type: "",
  ifsc_code: "",
  gst: "",
  is_default: 0,
};

const TeamPayoutAccountEditModal = ({
  open,
  onClose,
  account,
  accountIndex,
  onSave,
  businessTypes,
  taxLabel,
  allAccounts = [],
}) => {
  const [formValues, setFormValues] = useState(emptyAccountState);

  useEffect(() => {
    if (open && account) {
      setFormValues({
        ...emptyAccountState,
        ...account,
      });
    }
    if (!open) {
      setFormValues(emptyAccountState);
    }
  }, [open, account]);

  const handleFieldChange = (field) => (event) => {
    const { value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleDefaultToggle = (event) => {
    const isDefault = event.target.checked ? 1 : 0;
    setFormValues((prevValues) => ({
      ...prevValues,
      is_default: isDefault,
    }));
  };

  const handleSave = () => {
    if (!account) return;
    onSave(formValues);
  };

  const payoutAccountLabel =
    typeof accountIndex === "number"
      ? `PAYOUT ACCOUNT ${accountIndex + 1}`
      : "PAYOUT ACCOUNT";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{`Edit ${payoutAccountLabel}`}</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Business / Individual Name"
                size="small"
                value={formValues.business_name}
                onChange={handleFieldChange("business_name")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="edit-business-type-label">Business Type</InputLabel>
              <Select
                labelId="edit-business-type-label"
                label="Business Type"
                value={formValues.business_type || "None"}
                onChange={handleFieldChange("business_type")}
              >
                <MenuItem value="None" disabled>
                  <em>None</em>
                </MenuItem>
                {(businessTypes || []).map(({ label, value, disabled }, idx) => (
                  <MenuItem
                    key={`edit-business-type-${idx}-${value}`}
                    value={value}
                    disabled={disabled}
                  >
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Beneficiary Name"
                size="small"
                value={formValues.beneficiary_name}
                onChange={handleFieldChange("beneficiary_name")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Email"
                size="small"
                value={formValues.email}
                onChange={handleFieldChange("email")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Phone Number"
                size="small"
                value={formValues.phone}
                onChange={handleFieldChange("phone")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Account Number"
                size="small"
                value={formValues.account_no}
                onChange={handleFieldChange("account_no")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="Account Type"
                size="small"
                value={formValues.account_type}
                onChange={handleFieldChange("account_type")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="IFSC Code"
                size="small"
                value={formValues.ifsc_code}
                onChange={handleFieldChange("ifsc_code")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small">
              <TextField
                label="GST Number"
                size="small"
                value={formValues.gst}
                onChange={handleFieldChange("gst")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={Boolean(formValues.is_default)}
                  onChange={handleDefaultToggle}
                  color="primary"
                />
              }
              label="Set As Default Account"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton
          variant="contained"
          onClick={handleSave}
          disabled={!account}
        >
          Save Changes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default TeamPayoutAccountEditModal;
